@if (data) {
  <section>
    <div class="text-center">{{title}}
      <app-d3-pie [fontSize]="40" [data]="data" [innerRing]="60" (onSliceClick)="onSliceClick($event)" [legend]="legend"
      [width]="200" [height]="200" [margin]="{top:0, left:0, right:0, bottom:0}" [value]="value"></app-d3-pie>
    </div>
  </section>
}
